/**
 * Store overview vertical slider – runs after Swiper and GSAP are loaded.
 */
(function () {
  function initStoreOverview() {
    if (typeof Swiper === 'undefined') return;

    const section = document.querySelector('.store-overview');
    if (!section) return;

    const overlaySwiper = section.querySelector('.overlay_swiper2');
    const paginationLinks = section.querySelectorAll('.js-store-pagination');
    const indexEl = section.querySelector('.js-store-index');
    const scrollThumb = section.querySelector('.js-scroll-thumb');
    const totalSlides = section.querySelectorAll('.swiper-slide').length;

    if (totalSlides === 0) return;

    section.style.overflow = 'hidden';

    const swiperEl = section.querySelector('.mySwiper');
    if (!swiperEl) return;

    const swiperStore = new Swiper(swiperEl, {
      direction: 'vertical',
      slidesPerView: 1,
      spaceBetween: 0,
      mousewheel: true,
      speed: 500,
      threshold: 10,
    });

    function setActiveSlide(index) {
      paginationLinks.forEach(function (link, i) {
        link.classList.toggle('is-active', i === index);
        link.setAttribute('aria-selected', i === index);
      });
      if (indexEl) indexEl.textContent = index + 1;
      if (scrollThumb && totalSlides > 0) {
        scrollThumb.style.transform = 'scaleY(' + (index + 1) / totalSlides + ')';
      }
    }

    setActiveSlide(0);

    if (typeof gsap !== 'undefined') {
      gsap.from('.store-overview .store1', { y: 80, duration: 0.7, ease: 'power2.easeIn' });
    }

    paginationLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const i = parseInt(this.getAttribute('data-index'), 10);
        if (!isNaN(i)) swiperStore.slideTo(i);
      });
    });

    swiperStore.on('slideChange', function () {
      const index = this.realIndex;
      setActiveSlide(index);

      if (overlaySwiper) {
        overlaySwiper.style.display = 'block';
        setTimeout(function () {
          overlaySwiper.style.display = 'none';
        }, 400);
      }

      if (window.innerWidth > 749 && typeof gsap !== 'undefined') {
        const activeStore = section.querySelector('.swiper-slide-active .store');
        if (activeStore) {
          gsap.from(activeStore, { y: 80, duration: 0.7, ease: 'power2.easeIn', delay: 0.15 });
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoreOverview);
  } else {
    initStoreOverview();
  }
})();
